import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { LinearProgress, Box } from "@mui/material";

const ProtectedRoute = ({ children, editorOnly = false }) => {
  const { user, customClaims, loading, refetchAuth, lastFetched } = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);

  //console.log("ProtectedRoute: Checking authentication...");

  //console.trace();
  
  useEffect(() => {
    let isMounted = true;
    
    if (isMounted && Date.now() - lastFetched > 60000) {
      //console.log("🔄 Fetching fresh authentication data...");
      setIsRefreshing(true);
      refetchAuth().finally(() => {
        if (isMounted) setIsRefreshing(false);
      });
    }
  
    return () => { isMounted = false }; // Cleanup to avoid memory leaks
  }, []); // ✅ Only runs once on mount
  

  if (loading || isRefreshing) {
    //console.log("ProtectedRoute: Authentication loading...");
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1300, // Ensure it stays above everything
        }}
      >
        <LinearProgress
          sx={{
            backgroundColor: "transparent",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#EB494B",
            },
          }}
        />
      </Box>
    );
  }

  if (!user) {
    //console.log("ProtectedRoute: No user detected, redirecting to login...");
    return <Navigate to="/login" />;
  }

  if (editorOnly && !customClaims.isEditor) {
    //console.log("ProtectedRoute: User is not an editor, redirecting to home...");
    return <Navigate to="/" />;
  }

  //console.log("ProtectedRoute: Access granted.");
  return children;
};

export default ProtectedRoute;
